import React from 'react';
import { PaginationTable } from '@ver-uds/react';
import './DashboardLinkAccountsTable.scss';
import { CompanyName } from 'eve-account-client';
import { DashboardUser } from '@vis-auth/vis-user-client';
import { legacyUserColumns } from '../../../../constants/Dashboard';
import { legacyUserAccountsRows } from '../../../../utils/dashboardUtils';

export type DashboardLinkAccountsTableProps = {
  companyNames: CompanyName[];
  setShowLinkModal: (show: boolean) => void;
  setLinkUserLogonID: (logonId: string) => void;
  setShowUnlinkModal: (show: boolean) => void;
  triggerPasswordReset: () => void;
  filteredLegacyUsersUnlinkedAccounts: DashboardUser[];
};

const DashboardLinkAccountsTable = ({
  companyNames,
  setShowLinkModal,
  setLinkUserLogonID,
  setShowUnlinkModal,
  triggerPasswordReset,
  filteredLegacyUsersUnlinkedAccounts,
}: DashboardLinkAccountsTableProps): JSX.Element => {
  // Store the selected Users logonId so the Link Modal displays it as read only
  const onUserButtonClick = (logonId: string): void => {
    setLinkUserLogonID(logonId);
    setShowLinkModal(true);
  };

  const unlinkActionOnClick = (logonId: string): void => {
    setLinkUserLogonID(logonId);
    setShowUnlinkModal(true);
  };

  // The VerUds Table component inserts divs into the table structure when using floating columns options.
  // This generates warnings about validateDOMNesting that break our unit tests.
  // This will turn off the floatRowActions in unit tests to prevent the warnings breaking the tests.
  const disableActionsColumnFloat = process.env.NODE_ENV !== 'test';

  return (
    <div className="link-accounts-table-container">
      <PaginationTable
        id="legacy-user-accounts-table"
        sortable
        variant="default"
        columns={legacyUserColumns}
        floatRowActions={disableActionsColumnFloat}
        data={legacyUserAccountsRows(
          filteredLegacyUsersUnlinkedAccounts,
          companyNames,
          onUserButtonClick,
          unlinkActionOnClick,
          triggerPasswordReset,
        )}
      />
    </div>
  );
};

export default DashboardLinkAccountsTable;
